import { jsx } from "react/jsx-runtime";
import { useMemo, useCallback } from "react";
import { useWidgetConfig } from "@brandclub/bc-widgets";
import { PromptInputConcierge } from "../PromptInputConcierge/index.js";
const DEFAULT_PLACEHOLDER = "Ask me anything";
const DEFAULT_FOLLOW_UP_PLACEHOLDER = "Have another question?";
const ConciergeInputArea = ({
  searchInputValue,
  setSearchInputValue,
  handleSearch,
  isActivelyStreaming,
  conversationHistoryLength,
  onTrackAccessPoint,
  onStop,
  widgetId = "concierge-panel-chat-input",
  displayName = "Chat Input (Conversation)",
  initialState
}) => {
  const chatInputConfig = useWidgetConfig(widgetId, {});
  const homeInputConfig = useWidgetConfig("concierge-chat-input", {});
  const placeholder = useMemo(() => {
    if (conversationHistoryLength > 0) {
      return chatInputConfig.placeholderFollowUp || DEFAULT_FOLLOW_UP_PLACEHOLDER;
    }
    return chatInputConfig.placeholderDefault || DEFAULT_PLACEHOLDER;
  }, [conversationHistoryLength, chatInputConfig.placeholderDefault, chatInputConfig.placeholderFollowUp]);
  const handleSearchWithTracking = useCallback(
    (text, files) => {
      onTrackAccessPoint == null ? void 0 : onTrackAccessPoint("search_bar", text);
      handleSearch(text, files);
    },
    [handleSearch, onTrackAccessPoint]
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "tw:flex tw:shrink-0 tw:flex-col tw:gap-4 tw:px-4 tw:pt-1",
      style: { paddingBottom: "max(1rem, env(safe-area-inset-bottom))" },
      children: /* @__PURE__ */ jsx(
        PromptInputConcierge,
        {
          placeholder,
          value: searchInputValue,
          onChange: setSearchInputValue,
          onSubmit: handleSearchWithTracking,
          isStreaming: isActivelyStreaming,
          onStop,
          widgetId,
          displayName,
          initialState: {
            ...homeInputConfig.fontFamily ? { fontFamily: homeInputConfig.fontFamily } : {},
            ...initialState
          }
        }
      )
    }
  );
};
export {
  ConciergeInputArea
};
//# sourceMappingURL=ConciergeInputArea.js.map
